export default __webpack_public_path__ + "static/media/4.2b25a373.webp";